import { adminRoutes } from '@bettermode/domain/routes/web/admin'
import { T } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'

export function BillingBreadCrumb() {
  const { Link } = useRouter()
  return (
    <Link href={adminRoutes.billing.root}>
      <T id="Generics.Billing" defaultMessage="Billing" />
    </Link>
  )
}
